import React, {
    ChangeEvent,
    FC,
    FormEvent,
    useEffect,
    useState,
    KeyboardEvent,
} from 'react';
import Container from '../ui/container/container';
import data from '../db-local/db.json';
import parse from 'html-react-parser';
import '../style.sass';
import Input from '../ui/input/input';
import Textarea from '../ui/textarea/textarea';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import FooterComponent from '../components/footer.component';
import { Link } from 'react-router-dom';

const reEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const rePhone = /^\+?\d{10,15}$/;
const sender_url = 'https://sntx.ca/sender.php';

const HomePage: FC = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const [alertText, setAlertText] = useState<string>('');
    const [alertType, setAlertType] = useState<'success' | 'error' | ''>('');
    const [alertShow, setAlertShow] = useState<boolean>(false);
    const [captcha, setCaptcha] = useState<string>('');

    const formSchema = Object.keys(data.data[2].form as { [key: string]: string });

    const initialFormData = formSchema.reduce(
        (acc, key) => ({ ...acc, [key]: '' }),
        {} as { [key: string]: string }
    );

    const [formData, setFormData] = useState<{ [key: string]: string }>(initialFormData);
    const [touched, setTouched] = useState<{ [key: string]: boolean }>({});

    const isValid = {
        firstName: formData.firstName?.length >= 3,
        lastName: formData.lastName?.length >= 3,
        email: reEmail.test(formData.email),
        phone: rePhone.test(formData.phone),
        message: formData.message?.length >= 3,
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setTouched((prev) => ({ ...prev, [name]: true }));
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLFormElement>) => {
        if (e.key === 'Enter') {
            const target = e.target as HTMLElement;
            if (target.tagName !== 'TEXTAREA') {
                e.preventDefault();
                (e.target as HTMLFormElement).closest('form')?.dispatchEvent(
                    new Event('submit', { cancelable: true, bubbles: true })
                );
            }
        }
    };

    const sendForm = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!executeRecaptcha) {
            setAlertText('reCAPTCHA is unavailable');
            setAlertType('error');
            setAlertShow(true);
            return;
        }

        const token = await executeRecaptcha('submit_form');
        setCaptcha(() => token);

        if (formData.website.length === 0 && token) {
            const res = await fetch(sender_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...formData, recaptchaToken: token }),
            });

            const response = await res.json();

            if (response.success) {
                setAlertText(data.success_message);
                setAlertType('success');
                setAlertShow(true);
                setFormData(initialFormData);
                setTouched({});
            } else {
                setAlertText(data.error_message);
                setAlertType('error');
                setAlertShow(true);
            }
        }
    };

    useEffect(() => {
        if (alertShow) {
            const timeout = setTimeout(() => {
                setAlertShow(false);
                setAlertText('');
                setAlertType('');
            }, 5000);
            return () => clearTimeout(timeout);
        }
    }, [alertShow]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getInputClass = (name: string) => {
        if (!touched[name]) return '';
        if (name === 'website') return '';
        return isValid[name as keyof typeof isValid] ? 'valid' : 'invalid';
    };

    return (
        <>
            {alertShow && (
                <div className={`alert ${alertType}`}>
                    <span>{alertText}</span>
                </div>
            )}

            {data.data.map((item) => (
                <Container
                    key={item.id}
                    className={
                        item.id === 1
                            ? 'first'
                            : item.id === 2
                                ? 'second'
                                : item.id === 3
                                    ? 'third'
                                    : item.id === 4
                                        ? 'four'
                                        : ''
                    }
                >
                    {item.id === 1 && (
                        <div className={'topHeader'}>
                            <div className={'nav'}>
                                <Link to={''}>
                                    <img
                                        src={process.env.PUBLIC_URL + '/assets/img/logo.svg'}
                                        alt={'logo'}
                                    />
                                </Link>
                                {/*<Link to={'/policy.html'}>Privacy Policy</Link>*/}
                            </div>
                            <div className={'img'}>
                                <img
                                    src={process.env.PUBLIC_URL + '/assets/img/banner.png'}
                                    alt={'banner'}
                                />
                            </div>
                        </div>
                    )}

                    {
                        item.id === 4 &&

                        <div className={'iframe'}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2883.585459018898!2d-79.35112932320901!3d43.71916327109914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cddf955a393f%3A0x14da8e749f905453!2zMzAgSW5uIE9uIFRoZSBQayBEciwgTm9ydGggWW9yaywgT04gTTNDIDBQNywg0JrQsNC90LDQtNCw!5e0!3m2!1sru!2sru!4v1749646614369!5m2!1sru!2sru"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                style={{width: "100%", border: "none", height: "25rem"}}></iframe>
                        </div>
                    }

                    {item.id === 1 ? (
                        <h1 className={'header'}>
                            {parse(item.title)}
                            <span className={'point'}>.</span>
                        </h1>
                    ) : (
                        item.id !== 2 && <h2 className={'header'}>{item.title}</h2>
                    )}

                    {item.id === 1 && <div className={'hr'}/>}
                    {item.description && item.id !== 2 && (
                        <div className={'description'}>{parse(item.description)}</div>
                    )}
                    <div className={'parse_text'}>{item.text && parse(item.text)}</div>

                    {item.form && (
                        <form onSubmit={sendForm} onKeyDown={handleKeyDown}>
                            <input
                                type="text"
                                name="website"
                                value={formData.website}
                                onChange={handleChange}
                                style={{ display: 'none' }}
                            />
                            {Object.entries(item.form as {}).map(([name, label]) =>
                                name !== 'website' ? (
                                    name === 'message' ? (
                                        <Textarea
                                            className={`full ${getInputClass(name)}`}
                                            name={name}
                                            label={label as string}
                                            key={name}
                                            value={formData[name]}
                                            onChange={handleChange}
                                        />
                                    ) : (
                                        <Input
                                            name={name}
                                            label={label as string}
                                            key={name}
                                            className={getInputClass(name)}
                                            value={formData[name]}
                                            onChange={handleChange}
                                        />
                                    )
                                ) : null
                            )}
                            <p>{item.confirm_text} and <Link className={'link'} to={'/policy.html'}>privacy policy</Link></p>
                            <button
                                type={'submit'}
                                disabled={
                                    !!captcha ||
                                    !isValid.firstName ||
                                    !isValid.lastName ||
                                    !isValid.email ||
                                    !isValid.phone ||
                                    !isValid.message
                                }
                            >
                                Submit
                            </button>
                        </form>
                    )}

                    {item.content && (
                        <div className={`flex ${item.id % 2 !== 0 ? 'normal' : 'reverse'}`}>
                            <div className={'img'}>
                                <img src={process.env.PUBLIC_URL + item.img} alt={item.title} />
                            </div>
                            <div className={'text'}>
                                <h2>{item.title}</h2>
                                {item.description && (
                                    <div className={'description'}>{parse(item.description)}</div>
                                )}
                                <p>{parse(item.content)}</p>
                            </div>
                        </div>
                    )}
                    <FooterComponent item={item}/>
                </Container>
            ))}
        </>
    );
};

export default HomePage;